
(ns rothko.editor.manatee.markers 
  (:require
   [garden.color :refer [lighten rgb]]
   [garden.core :refer [css]]
   [garden.selectors :as selectors]
   [garden.units :refer [px]]))

#?(:clj
   (defn- set-marker-styles [css-string]
     nil)
   :cljs
   (defn- set-marker-styles [css-string]
     (let [style-id "marker-styles"
           doc js/document
           head (.-head doc)
           existing (.getElementById doc style-id)]
       (if existing
         (set! (.-innerHTML existing) css-string)
         (let [style-el (.createElement doc "style")]
           (.setAttribute style-el "type" "text/css")
           (.setAttribute style-el "id" style-id)
           (set! (.-innerHTML style-el) css-string)
           (.appendChild head style-el))))))

(def markers! (atom nil))

(defn install-markers
  "Installs a set of markers.  Call when rendering the annotation component.
   Pass in a structure of the form: {marker-keyword marker-colour, ...}.
   e.g. { :disfluency (rgb 255 140 0) :pronunciation (rgb 255 13 111)
          :partial (rgb 141 0 255) :backchannel (rgb 168 194 86)
          :spelling (rgb 255 140 0) :discontinuity (rgb 255 140 0) }
   N.B. The colours need to be processable, so use garden.color/rgb,
   not garden.stylesheet/rgb nor a string or other representation."
  [markers]

  (-> (css
       [:.annotator__toolbar-item
        (for [[name c] markers]
          [(selectors/& "." name)
           [:button
            {:color c}]])]
       [:.editor__edit
        (for [[name c] markers]
          [(selectors/& "." name)
           {:background-color (lighten c 40)
            :color c
            :outline [[(px 1) :dotted c]]}])]
       [:.editor__word
        (for [[name c] markers]
          [(selectors/& "." name)
           {:background-color (lighten c 40)
            :color c
            :outline [[(px 1) :dotted c]]}])])
      (set-marker-styles))
  
  (reset! markers! (set (keys markers))))

(defn match-markers [name]
  (contains? @markers! name))
